import { LoadingIndicatorProgress } from '@ohif/ui-next';

export default {
  'ui.loadingIndicatorProgress': LoadingIndicatorProgress,
};
